export enum CheckBoxCategorie {
    PTG = 'PTG',
    PTG_ATTRIBUTE = 'PTG_ATTRIBUTE',
    ATTRIBUTE = 'ATTRIBUTE',
    ORGANISATION = 'ORGANISATION',
    CERTIFICATION_ORGANISATION = 'CERTIFICATION_ORGANISATION',
    CERTIFICATION_ORGANISATION_ATTRIBUTE = 'CERTIFICATION_ORGANISATION_ATTRIBUTE',
    CERTIFICATION_ORGANISATION_PTG = 'CERTIFICATION_ORGANISATION_PTG',
    CERTIFICATION_ORGANISATION_TOOLCHAIN = 'CERTIFICATION_ORGANISATION_TOOLCHAIN',
    PRODUCT_ORGANISATION = 'PRODUCT_ORGANISATION',
    PRODUCT_ORGANISATION_SOFTWARE = 'PRODUCT_ORGANISATION_SOFTWARE',
    PRODUCT_ORGANISATION_DATABASE = 'PRODUCT_ORGANISATION_DATABASE',
    PRODUCT_ORGANISATION_SPEC_PUB = 'PRODUCT_ORGANISATION_SPEC_PUB',
    CERTIFICATION_TYPE = 'CERTIFICATION_TYPE',
    PRODUCT_CATEGORY = 'PRODUCT_CATEGORY',
    COMMON_FEATURE_ENTRY = 'COMMON_FEATURE_ENTRY',
    COMMON_FEATURE = 'COMMON_FEATURE',
    CERTIFICATION = 'CERTIFICATION',
    ATTR_CERTIFICATION = 'ATTR_CERTIFICATION',
    TOOLCHAIN_CERTIFICATION = 'TOOLCHAIN_CERTIFICATION',
    PTG_CERTIFICATION = 'PTG_CERTIFICATION',
    PRODUCTS = 'PRODUCTS',
    APP_PRODUCTS = 'APP_PRODUCTS',
    SERVICE_PRODUCTS = 'SERVICE_PRODUCTS',
    CONTENT_PRODUCTS = 'CONTENT_PRODUCTS',
    RATING = 'PRODUCT_RATING'
}

export class MarketplaceCheckbox {
    constructor(
        id: number,
        categorie: CheckBoxCategorie,
        label: string,
        ptgId: number,
        ptgOptional: boolean,
        isChecked: boolean,
        isVisible: boolean
    ) {
        this.id = id;
        this.categorie = categorie;
        this.label = label;
        this.ptgId = ptgId;
        this.ptgOptional = ptgOptional;
        this.isChecked = isChecked;
        this.isVisible = isVisible;
    }

    id: number;
    categorie: CheckBoxCategorie;
    label: string;
    ptgId: number;
    ptgOptional: boolean;
    isChecked: boolean;
    isVisible: boolean;
}
